import { combineReducers } from '@reduxjs/toolkit';
import dataSyncReducer from './dataSyncReducer.js';
const reducer = combineReducers({
  dataSyncReducer
});

export default reducer;